module.exports = new __parcel__URL__("empty-folder.884d4213.svg").toString();